import React, { useEffect, useState } from "react";
import { Box, Button, Flex, Text, Grid, GridItem } from "@chakra-ui/react";
import { Icon } from "@iconify/react";
import SectionWrapper from "../../components/SectionWrapper";
import { zones } from "../../utils/options";
import FullPageImageSlider from "../../components/FullPageImageSlider";
import ImgOptimized from "../../components/ImgOptimized";

const BestZones = ({ zoneImages = {} }) => {
  const [activeFilters, setActiveFilters] = useState("Reception");
  const [selectedImageIdx, setSelectedImageIdx] = useState(null);
  const [img, setImg] = useState([]);

  const toggleFilter = (filter) => {
    setActiveFilters(filter);
  };

  const filterButtons = zones.map((zone) => ({ key: zone, label: zone }));
  useEffect(() => {
    const pickRandomImages = (images) => {
      if (!images?.length) return [];

      // Group images by product (strip the trailing /number.ext to get product key)
      const productMap = {};
      images.forEach((url) => {
        const productKey = url.replace(/\/\d+\.[a-z]+(\?.*)?$/i, "");
        if (!productMap[productKey]) productMap[productKey] = [];
        productMap[productKey].push(url);
      });

      const productKeys = Object.keys(productMap);

      // Shuffle product keys
      const shuffledProducts = [...productKeys].sort(() => Math.random() - 0.5);

      const result = [];

      // First pass: pick one random image per unique product
      for (const key of shuffledProducts) {
        if (result.length >= 4) break;
        const productImages = productMap[key];
        const randomImage =
          productImages[Math.floor(Math.random() * productImages.length)];
        result.push(randomImage);
      }

      // If still need more (shortage of unique products), fill from any product
      if (result.length < 4) {
        const allShuffled = [...images].sort(() => Math.random() - 0.5);
        for (const img of allShuffled) {
          if (result.length >= 4) break;
          if (!result.includes(img)) result.push(img);
        }
      }

      return result;
    };

    const imagesForZone = zoneImages?.[activeFilters] || [];
    setImg(pickRandomImages(imagesForZone));
  }, [activeFilters, zoneImages]);
  // console.log("Images", img);

  // const imagesArr = [0, 1, 2, 3]
  //   .map((i) => getMinioImage(img?.[Math.floor(Math.random() * img.length)]))
  //   .filter(Boolean);
  console.log({ img, zoneImages });
  return (
    // <Box className="max-w-7xl mx-auto p-6 bg-gray-50 min-h-screen">
    <SectionWrapper heading={"Best Of Our Zones"}>
      {/* Header */}
      <>
        {/* Filters */}
        <Flex wrap="wrap" gap={3} mb={8} align="center">
          {filterButtons.map((filter) => (
            <Button
              key={filter.key}
              variant={activeFilters === filter.key ? "solid" : "outline"}
              colorScheme={activeFilters === filter.key ? "teal" : "gray"}
              size="sm"
              onClick={() => toggleFilter(filter.key)}
              className="transition-all duration-200"
            >
              {filter.label}
            </Button>
          ))}
        </Flex>

        {/* Main Content Grid */}
        <Grid templateColumns="repeat(2, 1fr)" gap={6} mb={12}>
          {/* Work Lounges - Large Image */}
          <GridItem colSpan={{ base: 2, lg: 1 }} className="relative group">
            <div
              className="relative overflow-hidden rounded-xl h-[400px] shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1"
              onClick={() => setSelectedImageIdx(0)}
              // style={{
              //   backgroundImage: `url(${getMinioImage(img?.[0])})`,
              //   backgroundSize: "cover",
              //   backgroundPosition: "center",
              //   height: "400px",

              // }}
            >
              {/* {img?.[0]} */}
              <ImgOptimized
                src={img?.[0]}
                width="100%"
                height="100%"
                alt="Work Lounges"
                className="w-full h-full  object-cover"
                isLazy={true}
              />
              <Box className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
              <Box className="absolute bottom-6 left-6">
                <Text fontSize="3xl" fontWeight="bold" color="white" mb={2}>
                  {activeFilters}
                </Text>
                <Flex align="center" gap={2}>
                  <Icon
                    icon="material-symbols:coffee-outline"
                    className="text-white"
                  />
                  <Text color="white" fontSize="sm">
                    Collaborative spaces
                  </Text>
                </Flex>
              </Box>
            </div>
          </GridItem>

          {/* Top Right Images */}
          <GridItem colSpan={{ base: 2, lg: 1 }}>
            <Grid templateColumns={"repeat(2, 1fr)"}>
              <GridItem
                colSpan={{ base: 2, lg: 2 }}
                display={"flex"}
                gap={"6"}
                justifyContent={"space-between"}
              >
                <Box
                  className="relative overflow-hidden rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
                  h="190px"
                  flexBasis={"50%"}
                  mb={4}
                  onClick={() => setSelectedImageIdx(1)}
                >
                  <ImgOptimized
                    src={img?.[1]}
                    width="100%"
                    height="100%"
                    alt="Work Lounges"
                    className="w-full h-full object-cover"
                    isLazy={true}
                  />
                  {/* <Box className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
            <Box className="absolute bottom-3 left-3">
              <Flex align="center" gap={2}>
                <Icon icon="material-symbols:desktop-windows-outline" className="text-white text-sm" />
                <Text color="white" fontSize="xs">Tech Hub</Text>
              </Flex>
            </Box> */}
                </Box>

                <Box
                  className="relative overflow-hidden rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
                  h="190px"
                  mb={4}
                  flexBasis={"50%"}
                  onClick={() => setSelectedImageIdx(2)}
                >
                  <ImgOptimized
                    src={img?.[2]}
                    width="100%"
                    height="100%"
                    alt="Work Lounges"
                    className="w-full h-full object-cover"
                    isLazy={true}
                  />
                  {/* <Box className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
            <Box className="absolute bottom-3 left-3">
              <Flex align="center" gap={2}>
                <Icon icon="material-symbols:business-center-outline" className="text-white text-sm" />
                <Text color="white" fontSize="xs">Executive</Text>
              </Flex>
            </Box> */}
                </Box>
              </GridItem>

              <GridItem colSpan={{ base: 2, lg: 2 }}>
                <Box
                  className="relative overflow-hidden rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
                  h="190px"
                  onClick={() => setSelectedImageIdx(3)}
                >
                  <ImgOptimized
                    src={img?.[3]}
                    width="100%"
                    height="100%"
                    alt="Work Lounges"
                    className="w-full h-full object-cover"
                    isLazy={true}
                  />
                  <Box className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                  <Box className="absolute bottom-3 left-3">
                    <Flex align="center" gap={2}>
                      <Icon
                        icon="material-symbols:meeting-room-outline"
                        className="text-white text-sm"
                      />
                      <Text color="white" fontSize="xs">
                        Conference Room
                      </Text>
                    </Flex>
                  </Box>
                </Box>
              </GridItem>
            </Grid>
          </GridItem>
        </Grid>
      </>
      {/* Explore More Section */}
      {selectedImageIdx !== null && (
        <FullPageImageSlider
          images={img}
          isOpen={selectedImageIdx !== null}
          onClose={() => setSelectedImageIdx(null)}
          initialIndex={selectedImageIdx}
        />
      )}
    </SectionWrapper>
    // {/* </Box> */}
  );
};

export default BestZones;
